document.addEventListener('DOMContentLoaded', () => {
  const carousel = document.querySelector('.js-testimonials-carousel');
  if (!carousel) return;

  const list = carousel.querySelector('.splide__list');
  if (!list) return;

  let slides = Array.from(list.querySelectorAll('.js-testimonial'));

  if (!slides.length) return;

  slides = slides
    .sort(() => Math.random() - 0.5)
    .slice(0, 10);

  list.innerHTML = '';

  slides.forEach((slide) => {
    list.appendChild(slide);
  });

  const isDesktop = window.innerWidth > 991;

  if (isDesktop && typeof Splide !== 'undefined') {
    new Splide(carousel, {
      type: 'loop',
      perPage: 2,
      perMove: 1,
      gap: '16px',
      arrows: false,
      pagination: false,
      drag: true,
      autoScroll: {
        speed: 0.8,
        pauseOnHover: true,
        pauseOnFocus: false,
      },

      autoplay: false,

      breakpoints: {
        991: {
          destroy: true
        }
      }
    }).mount(window.splide.Extensions);
  }
});